import sanitizeHtml from 'sanitize-html'

// HTMLの作成マニュアルに記載のタグ・attributeを許可対象として指定
// https://www.notion.so/HTML-_2311ver-b49c6b87fdbc4b55bbd23369c6407240
const ALLOWED_TAGS = ['img', 'button', 'iframe']
const ALLOWED_ATTRIBUTES = ['id', 'class', 'width', 'height', 'style', 'data-*']
// youtubeの埋め込みに使用するattributeのみ許可対象として指定
const IFRAME_ALLOWED_ATTRIBUTES = [
  'src',
  'width',
  'height',
  'title',
  'frameborder',
  'allow',
  'referrerpolicy',
  'allowfullscreen'
]

export default {
  sanitize(html) {
    const options = {
      // sanitizeHtmlのデフォルトで許可されているタグやAttributeは下記参照。
      // https://github.com/apostrophecms/sanitize-html?tab=readme-ov-file#default-options
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(ALLOWED_TAGS),
      allowedAttributes: {
        a: sanitizeHtml.defaults.allowedAttributes.a,
        img: sanitizeHtml.defaults.allowedAttributes.img,
        iframe: IFRAME_ALLOWED_ATTRIBUTES,
        '*': ALLOWED_ATTRIBUTES
      },
      allowedIframeHostnames: ['www.youtube.com'], // youtubeのみiframeで埋込許可
      allowedClasses: false
    }
    return sanitizeHtml(html, options)
  }
}
